import {
  BrandKit,
  InputStyleDefinition,
  Override,
} from "@redotech/redo-model/brand-kit";
import { getInputStyles } from "@redotech/redo-model/brand-kit/utils";
import {
  RedoDateInput,
  RedoDateInputProps,
} from "./arbiter-components/input/redo-date-input";
import * as css from "./brand-kit-text-input.module.css";

export const BrandKitDateInput = function BrandKitDateInput({
  brandKit,
  override,
  ...props
}: RedoDateInputProps & {
  brandKit: BrandKit;
  override?: Override<InputStyleDefinition>;
}) {
  const style = getInputStyles(brandKit, override);
  return (
    <RedoDateInput
      className={css.brandKitTextInput}
      dangerousStyleThatShouldOnlyBeUsedForMerchantBranding={style}
      {...props}
    />
  );
};
